import Vue from 'vue'
import moment from 'moment'
import Router, { Route } from 'vue-router'
import {isPinChangedGuard, isUserLoggedInGuard, loginPageGuard, rootPageGuard, tenantRedirectionGuard} from '@/router/guards'
import LoginPage from '@/pages/LoginPage.vue'
import PasswordRecoveryPage from '@/pages/PasswordRecoveryPage.vue'
import ChangePinPage from '@/pages/ChangePinPage.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
import OrderPage from '@/pages/OrderPage.vue'
import PaymentPage from '@/pages/PaymentPage.vue'
import CreditPage from "@/pages/CreditPage.vue";
import BillingPage from "@/pages/BillingPage.vue";
import PermalinkPage from "@/pages/PermalinkPage.vue";
import MyOrderPage from "@/pages/MyOrderPage.vue";
import UserQrCode from "@/components/dashboard/UserQrCode.vue";
import RedirectToNewAddressPage from '@/pages/RedirectToNewAddressPage.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'Root',
      beforeEnter: rootPageGuard
    },
    {
      path: '/login',
      name: 'Login',
      beforeEnter: loginPageGuard,
      component: LoginPage
    },
    {
      path: '/password-recovery/:recoveryCode?',
      name: 'PasswordRecovery',
      beforeEnter: loginPageGuard,
      component: PasswordRecoveryPage,
      props: (route: Route) => ({
        recoveryCode: route.params.recoveryCode
      })
    },
    {
      path: '/change-password',
      name: 'ChangePin',
      beforeEnter: isPinChangedGuard,
      component: ChangePinPage
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      beforeEnter: isUserLoggedInGuard,
      component: DashboardPage
    },
    {
      path: '/order/:isoWeek?/:date?',
      name: 'Order',
      beforeEnter: isUserLoggedInGuard,
      component: OrderPage,
      props: (route: Route) => ({
        isoWeek: route.params.isoWeek,
        date: route.params.date && moment(route.params.date).toDate() || undefined
      })
    },
    {
      path: '/payment/:date',
      name: 'Payment',
      beforeEnter: isUserLoggedInGuard,
      component: PaymentPage,
    },
    {
      path: '/my-orders',
      name: 'myOrder',
      beforeEnter: isUserLoggedInGuard,
      component: MyOrderPage,
    },
    {
      path: '/credit',
      name: 'Credit',
      beforeEnter: isUserLoggedInGuard,
      component: CreditPage
    },
    {
      path: '/billing',
      name: 'Billing',
      beforeEnter: isUserLoggedInGuard,
      component: BillingPage
    },
    {
      path: '/ln/:link',
      name: 'Permalink',
      component: PermalinkPage,
      props: (route: Route) => ({
        link: route.params.link,
      })
    },
    {
      path: '/userQr',
      name: 'userQrCode',
      beforeEnter: isUserLoggedInGuard,
      component: UserQrCode,

    },
    {
      path: '/redirect-to-new-address',
      name: 'RedirectToNewAddress',
      beforeEnter: isUserLoggedInGuard,
      component: RedirectToNewAddressPage
    },
    {
      path: '*',
      redirect: '/dashboard'
    }
  ]
})

router.beforeEach(tenantRedirectionGuard)

export default router
